module.exports = __webpack_public_path__ + "static/img/location.bfdadfc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/location.svg
// module id = OJY6
// module chunks = 1